















import { computed, defineComponent } from '@vue/composition-api';
import { isOverseasVersion } from 'common-module/src/util';
import { useRouteState } from './useFloatAction';
import SceneGuide from '../SceneGuide/index.vue';

export default defineComponent({
  name: 'FloatLeftContent',
  components: { SceneGuide },
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const { isNotFound, isSettingPage, isCreateProjectPage, isRecorderViewPage, isSharePage } = useRouteState();
    const isShow = computed(() => !isNotFound.value &&
      !isSettingPage.value &&
      !isCreateProjectPage.value &&
      !isRecorderViewPage.value &&
      !isSharePage.value
    );

    return {
      isShow,
      isOverseas: isOverseasVersion
    };
  }
});
